import { render, staticRenderFns } from "./PendingReview.vue?vue&type=template&id=5bd44944&scoped=true"
import script from "./PendingReview.vue?vue&type=script&lang=js"
export * from "./PendingReview.vue?vue&type=script&lang=js"
import style0 from "./PendingReview.vue?vue&type=style&index=0&id=5bd44944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd44944",
  null
  
)

export default component.exports